module.exports = __webpack_public_path__ + "static/media/info_icon.6b17061e.svg";